import { Card, Row, Spin } from "antd";
import { memo, useCallback, useState } from "react";
import { useFormattedBalance } from "../../hooks/useFormattedBalance";
import { useFetchData } from "./hooks/useFetchData";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../../lib/constants";
import { useDoubleLineChartConfig } from "../../hooks/useDoubleLineChartConfig";
import { Line } from "@ant-design/plots";
import { DefaultLegend } from "../DefaultLegend";
import { Header } from "./components/Header";

type TransactionAmountsProps = {
  amounts: any;
  isDataLoading: boolean;
  isRecalculated: boolean;
};

const TransactionAmounts = ({
  amounts,
  isDataLoading,
  isRecalculated,
}: TransactionAmountsProps) => {
  const [granularity, setGranularity] = useState<number>(1);

  const { getFormattedBalance } = useFormattedBalance();

  const { data, isLoading } = useFetchData(isRecalculated, granularity);

  const getColor = useCallback(({ type }: { type: string }): string => {
    return type === "Payments" ? CHART_PAID_OFF : CHART_DEFAULT;
  }, []);

  const { config } = useDoubleLineChartConfig(data, getColor, true);

  return (
    <Card className="dashboard-card top">
      <Header granularity={granularity} setGranularity={setGranularity} />
      <Row className="d-block h-100">
        {!isDataLoading && !isLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">
                  {getFormattedBalance(amounts[granularity].payments)}
                </h3>
                <p className="my-0 text-sm title">total payments</p>
              </Row>
              <Row className="d-block">
                <h3 className="h h3">
                  {getFormattedBalance(amounts[granularity].disbursements)}
                </h3>
                <p className="my-0 text-sm title">total disbursements</p>
              </Row>
            </Row>

            <Line {...config} />

            <DefaultLegend first="Payments" second="Disbursements" />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};

export default memo(TransactionAmounts);
